import createSharedStateHook from './use-shared-state.js';

export const useHideSubBox = createSharedStateHook('hideSubBox', App.isSubscribed);
export const setHideSubBox = useHideSubBox.set;
